export default __webpack_public_path__ + "static/media/Projectplan.cff2e292.pdf";